var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParticipants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7923 9.52368C21.5824 10.3137 21.5824 11.5946 20.7923 12.3846C20.0023 13.1747 18.7214 13.1747 17.9314 12.3846C17.1414 11.5946 17.1414 10.3137 17.9314 9.52368C18.7214 8.73364 20.0023 8.73364 20.7923 9.52368",
    stroke: "#567783",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2024 5.91236C15.4189 7.12884 15.4189 9.10115 14.2024 10.3176C12.9859 11.5341 11.0136 11.5341 9.79713 10.3176C8.58065 9.10116 8.58065 7.12885 9.79713 5.91236C11.0136 4.69588 12.9859 4.69588 14.2024 5.91236",
    stroke: "#567783",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06871 9.52368C6.85874 10.3137 6.85874 11.5946 6.06871 12.3846C5.27868 13.1747 3.99779 13.1747 3.20776 12.3846C2.41773 11.5946 2.41773 10.3137 3.20776 9.52368C3.99779 8.73364 5.27868 8.73364 6.06871 9.52368",
    stroke: "#567783",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 18.9998V17.9038C23.0002 16.5228 21.8812 15.4038 20.5002 15.4038H19.6992",
    stroke: "#567783",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.9998V17.9038C1 16.5228 2.119 15.4038 3.5 15.4038H4.301",
    stroke: "#567783",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3392 18.9999V17.3989C17.3392 15.4659 15.7722 13.8989 13.8392 13.8989H10.1602C8.22716 13.8989 6.66016 15.4659 6.66016 17.3989V18.9999",
    stroke: "#567783",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/participants.4da8b4690da56f52d84332e285a83e85.svg";
export { ForwardRef as ReactComponent };